import React, { useState, useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Фикс для иконок Leaflet в React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

const UiMapOSM = (props) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const deliveryZonesRef = useRef([]);
  const mapInstanceRef = useRef(null);
  const [map, setMap] = useState(null);
  const [deliveryPoint, setDeliveryPoint] = useState(null);

  // Геоданные зон доставки
  const geoJsonData = {
    type: "FeatureCollection",
    metadata: {
      name: "mate",
      creator: "Yandex Map Constructor",
    },
    features: [
      {
        type: "Feature",
        id: 0,
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [37.405291107925656, 55.69751254027933],
              [37.4331798575516, 55.662407917119886],
              [37.45969531616205, 55.63892475800462],
              [37.49334094604485, 55.60959111405624],
              [37.51325366577141, 55.59442999879288],
              [37.59771106323236, 55.57459504460255],
              [37.65195605834954, 55.571871814267034],
              [37.687661624755805, 55.575762085252094],
              [37.73023364624014, 55.592680260636655],
              [37.7837919958495, 55.617946648668976],
              [37.834113536662365, 55.65019786505358],
              [37.83995002347877, 55.658738799866235],
              [37.831710277385035, 55.68745366846508],
              [37.829650340861576, 55.698894912181686],
              [37.838576732463146, 55.71382164733274],
              [37.843039928263934, 55.77753503296386],
              [37.83754676420142, 55.82240082696482],
              [37.7891382559006, 55.850415591228476],
              [37.726310191935646, 55.88265576176632],
              [37.70159095365438, 55.894232495214716],
              [37.646659313029396, 55.89654742576664],
              [37.59447425443565, 55.908505690790356],
              [37.57318824369345, 55.91159109370418],
              [37.480491100138764, 55.88574322976519],
              [37.445472179240284, 55.88188385620098],
              [37.40976661283404, 55.870110386675584],
              [37.39740699369341, 55.85852642708045],
              [37.391913829630916, 55.847904749659435],
              [37.39363044340046, 55.82568636533217],
              [37.384704051798884, 55.8011347240865],
              [37.370971141642634, 55.787595673353366],
              [37.36939648373389, 55.74692507509003],
              [37.37694958431984, 55.7312361330751],
              [37.38827923519874, 55.709726183329856],
              [37.405291107925656, 55.69751254027933],
            ],
          ],
        },
        properties: {
          fill: "#ed4543",
          "fill-opacity": 0,
          stroke: "#ed4543",
          "stroke-width": 2,
          "stroke-opacity": 0.5,
          description: "Зона доставки",
        },
      },
    ],
  };

  // ============== ВСЕ ФУНКЦИИ ОБЪЯВЛЯЕМ ДО ИХ ИСПОЛЬЗОВАНИЯ ==============

  // Функция создания иконки маркера
  const createMarkerIcon = (color = "black") => {
    return L.divIcon({
      className: "custom-div-icon",
      html: `<div style="background-color: ${color}; width: 20px; height: 20px; border-radius: 50%; border: 3px solid white; box-shadow: 0 0 10px rgba(0,0,0,0.3);"></div>`,
      iconSize: [20, 20],
      iconAnchor: [10, 10],
    });
  };

  // Функция геокодирования адреса
  const geocodeAddress = async (address) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}&limit=1`,
      );
      const data = await response.json();
      if (data && data.length > 0) {
        return {
          lat: parseFloat(data[0].lat),
          lng: parseFloat(data[0].lon),
          displayName: data[0].display_name,
        };
      }
      return null;
    } catch (error) {
      console.error("Geocoding error:", error);
      return null;
    }
  };

  // Обратное геокодирование
  const reverseGeocode = async (lat, lng) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`,
      );
      const data = await response.json();
      if (data && data.display_name) {
        return data.display_name;
      }
      return "Не удалось определить адрес";
    } catch (error) {
      console.error("Reverse geocoding error:", error);
      return "Не удалось определить адрес";
    }
  };

// Функция проверки вхождения точки в зону доставки (ИСПРАВЛЕННАЯ)
const isPointInZone = (lat, lng, zone) => {
  const coordinates = zone.geometry.coordinates[0];
  let inside = false;
  
  for (let i = 0, j = coordinates.length - 1; i < coordinates.length; j = i++) {
    const xi = coordinates[i][0]; // долгота
    const yi = coordinates[i][1]; // широта
    const xj = coordinates[j][0]; // долгота
    const yj = coordinates[j][1]; // широта
    
    const intersect = ((yi > lat) !== (yj > lat)) &&
      (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
};

// Функция поиска зоны доставки с отладкой
const findDeliveryZone = (lat, lng) => {
  console.log("=== ПРОВЕРКА ЗОНЫ ДОСТАВКИ ===");
  console.log("Координаты точки:", lat, lng);
  console.log("Количество зон:", deliveryZonesRef.current.length);
  
  if (!deliveryZonesRef.current || deliveryZonesRef.current.length === 0) {
    console.log("Зоны доставки не загружены");
    return null;
  }
  
  for (let i = 0; i < deliveryZonesRef.current.length; i++) {
    const zone = deliveryZonesRef.current[i];
    const isInside = isPointInZone(lat, lng, zone);
    console.log(`Зона ${i}:`, zone.properties.description, "Внутри:", isInside);
    if (isInside) {
      console.log("✅ Точка внутри зоны!");
      return zone;
    }
  }
  console.log("❌ Точка вне всех зон");
  return null;
};

// Функция подсветки результата (с отладкой)
const highlightResult = async (lat, lng) => {
  console.log("=== HIGHLIGHT RESULT ===");
  console.log("Точка:", lat, lng);
  
  const zone = findDeliveryZone(lat, lng);

  if (zone) {
    console.log("В зоне доставки!");
    const color = zone.properties.fill || "#ed4543";
    updateMarkerIcon(color);
    props.onChange(0); // 0 минут доставки
  } else {
    console.log("Вне зоны доставки!");
    updateMarkerIcon("black");

    try {
      const response = await fetch(
        `https://router.project-osrm.org/route/v1/driving/37.527034,55.654884;${lng},${lat}?overview=false`,
      );
      const data = await response.json();
      if (data.routes && data.routes.length > 0) {
        const distance = Math.ceil(data.routes[0].distance / 1000);
        console.log("Расстояние:", distance, "км");
        props.onChange(distance);
      } else {
        props.onChange(5);
      }
    } catch (error) {
      console.error("Route calculation error:", error);
      props.onChange(5);
    }
  }
};

 

  // Функция обновления иконки маркера (вместо пересоздания)
  const updateMarkerIcon = (color = "black") => {
    if (markerRef.current) {
      const newIcon = createMarkerIcon(color);
      markerRef.current.setIcon(newIcon);
    }
  };

 

  // Инициализация карты
  useEffect(() => {
    if (!mapRef.current) return;

    const mapInstance = L.map(mapRef.current, {
      center: [55.755863, 37.6177],
      zoom: 13,
      zoomControl: false,
    });

    mapInstanceRef.current = mapInstance;

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "",
    }).addTo(mapInstance);

    // Создание маркера
    const marker = L.marker([55.755863, 37.6177], {
      draggable: true,
      icon: createMarkerIcon("black"),
    }).addTo(mapInstance);

    markerRef.current = marker;
    setDeliveryPoint(marker);

    // Обработка перетаскивания маркера
    marker.on("dragend", async (e) => {
      const position = marker.getLatLng();
      const address = await reverseGeocode(position.lat, position.lng);
      props.onChangeAddress(address);
      await highlightResult(position.lat, position.lng);
    });

    // Обработка клика по карте
    mapInstance.on("click", async (e) => {
      const { lat, lng } = e.latlng;
      
      // Перемещаем маркер
      markerRef.current.setLatLng([lat, lng]);
      
      const address = await reverseGeocode(lat, lng);
      props.onChangeAddress(address);
      await highlightResult(lat, lng);
    });

    // Добавление зон доставки
    const zones = [];
    geoJsonData.features.forEach((feature) => {
      const coordinates = feature.geometry.coordinates[0];
      const latLngs = coordinates.map((coord) => [coord[1], coord[0]]);

      const polygon = L.polygon(latLngs, {
        color: feature.properties.stroke || "#ed4543",
        weight: feature.properties["stroke-width"] || 2,
        opacity: feature.properties["stroke-opacity"] || 0.5,
        fillColor: feature.properties.fill || "#ed4543",
        fillOpacity: 0.01,
      }).addTo(mapInstance);

      polygon.on("click", async (e) => {
        const { lat, lng } = e.latlng;
        
        // Перемещаем маркер
        markerRef.current.setLatLng([lat, lng]);
        
        const address = await reverseGeocode(lat, lng);
        props.onChangeAddress(address);
        await highlightResult(lat, lng);
      });

      zones.push(feature);
    });

    deliveryZonesRef.current = zones;
    setMap(mapInstance);

    return () => {
      if (mapInstance) {
        mapInstance.remove();
      }
    };
  }, []);

  // Обработка изменения адреса извне
  useEffect(() => {
    if (props.address && map && markerRef.current) {
      geocodeAddress(props.address).then(async (result) => {
        if (result) {
          markerRef.current.setLatLng([result.lat, result.lng]);
          map.setView([result.lat, result.lng], 13);
          await highlightResult(result.lat, result.lng);
        }
      });
    }
  }, [props.address, map]);

  return (
    <div
      className="map-address"
      ref={mapRef}
      style={{ width: "100%", height: "400px" }}
    ></div>
  );
};

export default UiMapOSM;